<template>
  <div>
    <section v-if="clientInfo">
      <v-card class="elevation-0 transparent">
        <v-card-title :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <h1 v-if="$vuetify.breakpoint.mdAndUp" class="text-center">Edit Client : {{clientInfo.id}} -
            {{clientInfo.name}}</h1>
          <h1 v-else class="text-center">
            <div>Edit Client : {{clientInfo.id}}</div>
            <div> {{clientInfo.name}}</div>
          </h1>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon color="blue darken-1" v-on="on" @click="toggleBarcodeDialog">
                <v-icon>
                  mdi-barcode
                </v-icon>
              </v-btn>
            </template>
            <span>Edit client Barcode Identifiers</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon color="blue darken-1" v-on="on" @click="getPricing" v-if="readPricingPermission">
                <v-icon>
                  local_atm
                </v-icon>
              </v-btn>
            </template>
            <span>Edit client pricing</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon color="blue darken-1" v-on="on" @click="editPermissions" v-if="editPermissionsPermission">
                <v-icon>
                  lock_open
                </v-icon>
              </v-btn>
            </template>
            <span>Edit default permissions</span>
          </v-tooltip>
        </v-card-title>
        <v-container container--fluid grid-list-xl>
          <v-row justify="space-around">
            <v-col cols="12" sm="12" md="6">

              <v-expansion-panels accordion multiple>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>Client Information</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ClientInformation
                      v-if="clientInfo"
                      :client-info="clientInfo"
                      :readonly="clientInfo.id !== 0">
                    </ClientInformation>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>Contact Details</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ClientDetails
                      v-if="clientInfo"
                      :other-fields="true"
                      :client-info="clientInfo">
                    </ClientDetails>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>Accounting Information</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <AccountingInformation
                      v-if="clientInfo"
                      :client-info="clientInfo">
                    </AccountingInformation>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>SMS Settings</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <SmsSettings
                      v-if="clientInfo"
                      :client-info="clientInfo">
                    </SmsSettings>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>Report Settings</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ReportSettings
                      v-if="clientInfo"
                      :client-info="clientInfo">
                    </ReportSettings>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>LineHaul Settings</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ClientLinehaulSetting
                      v-if="clientInfo"
                      :client-info="clientInfo">
                    </ClientLinehaulSetting>
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>

            </v-col>

            <v-col cols="12" sm="12" md="6">

              <v-expansion-panels accordion multiple>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>POD Settings</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <PodSettings
                      v-if="clientInfo"
                      :client-info="clientInfo">
                    </PodSettings>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>Tracking Settings</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <TrackingSettings
                      v-if="clientInfo"
                      :client-info="clientInfo">
                    </TrackingSettings>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>Production Information</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ProductionInformation
                      v-if="clientInfo"
                      :client-info="clientInfo">
                    </ProductionInformation>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>Courier Settings</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <CourierSettings
                      v-if="clientInfo"
                      :client-info="clientInfo">
                    </CourierSettings>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h2>API Settings</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ApiSettings
                      v-if="id"
                      :client-id="id">
                    </ApiSettings>
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>

            </v-col>
          </v-row>
          <v-card-actions class="justify-center">
            <v-btn text color="blue-grey lighten-2" :to="'/clients'">Cancel</v-btn>
            <v-btn text color="blue darken-1" @click="saveChanges()">Save</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </section>

    <v-dialog width="800px" v-model="pricingShow" v-if="clientPricing && readPricingPermission">
      <ClientPricing :toggle-dialog="toggleDialog"
                     :client-pricing="clientPricing"
                     :id="id"
      ></ClientPricing>
    </v-dialog>
    <v-dialog width="800px" v-model="permissionsShow" v-if="clientPermissions && editPermissionsPermission">
      <ClientPermissions :toggle-dialog="togglePermissionsDialog"
                         :client-permissions="clientPermissions"
                         :id="id"
      ></ClientPermissions>
    </v-dialog>
    <v-dialog width="800px" v-model="barcodeShow" v-if="barcodeShow">
      <ClientBarcodes :toggle-dialog="toggleBarcodeDialog"
                     :client-barcode="barcodeIdentifiers"
                      v-on:update:identifiers="barcodeIdentifiers = $event"
                     :id="id"
      ></ClientBarcodes>
    </v-dialog>
  </div>
</template>

<script>
    import axios from 'axios'
    import ClientInformation from "./util/Clients/ClientInformation";
    import ClientDetails from "./util/Clients/ClientDetails";
    import AccountingInformation from "./util/Clients/AccountingInformation"
    import SmsSettings from "./util/Clients/SmsSettings";
    import ReportSettings from "./util/Clients/ReportSettings";
    import PodSettings from "./util/Clients/PodSettings";
    import TrackingSettings from "./util/Clients/TrackingSettings";
    import ProductionInformation from "./util/Clients/ProductionInformation";
    import CourierSettings from "./util/Clients/CourierSettings";
    import ClientBarcodes from "./util/Clients/ClientBarcodes";
    import ClientPricing from "./util/Clients/ClientPricing";
    import ClientPermissions from "./util/Clients/ClientPermissions";
    import ApiSettings from "./util/Clients/ApiSettings";
    import ClientLinehaulSetting from "./util/Clients/ClientLinehaulSetting.vue";

    export default {
        name: "EditClient",
        components: {
            ClientLinehaulSetting,
            ClientBarcodes,
            ClientPricing,
            ClientPermissions,
            CourierSettings,
            ProductionInformation,
            TrackingSettings,
            PodSettings,
            ReportSettings,
            SmsSettings,
            AccountingInformation,
            ClientDetails,
            ClientInformation,
            ApiSettings
        },
        data() {
            return {
                id: null,
                barcodeIdentifiers: null,
                barcodeShow: false,
                clientInfo: null,
                clientPricing: null,
                clientPermissions: null,
                pricingShow: false,
                permissionsShow: false,
                barcode:[],
                isBarcode:true,
            }
        },
        methods: {
            getClientInfo(id) {
                axios.get(process.env.API_URL + '/clients/' + id)
                    .then((response) => {
                        this.clientInfo = response.data;
                    })
                    .catch((error) => {
                        console.log(error.response.error);
                    })
                axios.get(process.env.API_URL + '/clients/' + this.id + '/barcode')
                  .then((response) => {
                    this.barcodeIdentifiers = response.data.map(id => { return id.identifier; });
                  })
                  .catch((response) => {
                    this.clientInfo = null; // Avoid accidentally deleting barcode identifiers if not loaded correctly
                    this.$store.commit('displaySnackbar','ERROR: ' + (response.data !== undefined ? response.data.error : 'An unknown error occurred'));
                  });
            },
            saveChanges() {
                if (this.clientInfo.id > 0) {
                  var barcodeUpcase = [];
                  this.barcodeIdentifiers.forEach((item) => {
                    barcodeUpcase.push(item.toUpperCase());
                  });
                  this.clientInfo.barcode_identifier = barcodeUpcase;
                    axios.put(process.env.API_URL + '/clients/' + this.id, this.clientInfo)
                        .then((response) => {
                            this.clientInfo = response.data;
                            this.$router.push('clients');
                        })
                        .catch((err) => {
                            this.$store.commit('displaySnackbar','ERROR: ' + (err.response.data !== undefined ? err.response.data.error : 'An unknown error occurred'));
                        })
                } else {
                    axios.post(process.env.API_URL + '/clients', this.clientInfo)
                        .then((response) => {
                            this.clientInfo = response.data;
                            this.$router.push('clients');
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar','ERROR: ' + (response.data !== undefined ? response.data.error : 'An unknown error occurred'));
                        })
                }
            },
            getPricing() {
                if (this.clientInfo.use_postcode_billing) {
                    alert('This client is currently using postcode billing, please contact support to change pricing data');
                } else {
                    axios.get(process.env.API_URL + '/clients/' + this.id + '/pricing')
                        .then((response) => {
                            this.clientPricing = response.data;
                            this.pricingShow = true;
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar','ERROR: ' + (response.data !== undefined ? response.data.error : 'An unknown error occurred'));
                        });
                }
            },
            editPermissions() {
                axios.get(process.env.API_URL + '/clients/' + this.id + '/regions/0/permissions')
                    .then((response) => {
                        if (response.status === 200) {
                            this.clientPermissions = response.data;
                        } else {
                            this.clientPermissions = [];
                        }
                        this.permissionsShow = true;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar','ERROR: ' + (response.data !== undefined ? response.data.error : 'An unknown error occurred'));
                    });
            },
            toggleDialog() {
                this.pricingShow = !this.pricingShow;
            },
            togglePermissionsDialog() {
                this.permissionsShow = !this.permissionsShow;
            },
            toggleBarcodeDialog() {
              this.barcodeShow = !this.barcodeShow;
            }
        },
        mounted() {
            this.id = parseFloat(this.$route.query.id);

            if (this.id !== 0 && this.id !== undefined) {
                this.getClientInfo(this.id);
            } else {
                this.clientInfo = {
                    id: 0,
                    logo: 'http://bcrc.io/logo.png',
                }
            }
        },
        computed: {
            readPricingPermission() {
                return this.$store.getters['auth/hasPermission']('client_pricing_view');
            },
            editPermissionsPermission() {
                if (this.$store.getters['auth/isInternalUser']) {
                    return this.$store.getters['auth/hasPermission']('client_edit');
                } else {
                    return this.$store.getters['auth/hasPermission']('vendor_admin');
                }
            }
        },
        watch: {
            clientInfo: {
                handler: function () {

                },
                deep: true
            }
        }
    }
</script>

<style>

  .v-expansion-panel-content__wrap {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/EditClient.vue